import { AppThunkAction } from '.';
import { Action, Reducer } from 'redux'
import * as myCfg from '../AppConfig';
import { APIContainer, LogTypes, sawinFunc } from './sawinLib';
import { SessionModel } from '../models/SessionModel';
import * as CustomerRequestInitalDataMdl from '../models/CustomerRequestInitialData';

export interface CustomerRequestInitialDataLoading { type: 'CUSTOMERREQUESTINITIALDATA_LOADING', loading: boolean }
export interface CustomerRequestInitialDataLoadInfo { type: 'CUSTOMERREQUESTINITIALDATA_LOADINFO', data: CustomerRequestInitalDataMdl.CustomerRequestInitialData }
export interface CustomerRequestInitialDataLoadTaskList { type: 'CUSTOMERREQUESTINITIALDATA_LOADTASKS', data: CustomerRequestInitalDataMdl.CustomerRequestTaskInfoItem[] }
export interface CustomerRequestInitialDataError { type: 'CUSTOMERREQUESTINITIALDATA_ERROR', error: string }

export type KnownAction = CustomerRequestInitialDataLoading | CustomerRequestInitialDataLoadInfo | CustomerRequestInitialDataError | CustomerRequestInitialDataLoadTaskList;

export const actionCreators = {
    loadInitialData: (serviceDateRequested: Date, taskCode: string, serviceOrMaintenance:string): AppThunkAction<KnownAction> => (dispatch, getState) => {
        const appState = getState();
        const sessionState: SessionModel = appState.sessionState;        
        var CompanyCode = sessionState.SelectedAR.companyCode;
        const serviceMasterNum = sessionState.SelectedSM.id;
        const taskCodeSplit: string[] = taskCode.split('.');
        const functionCode = taskCodeSplit[0];
        const componentCode = taskCodeSplit[1];

        dispatch({ type: 'CUSTOMERREQUESTINITIALDATA_LOADING', loading: true });
        sawinFunc.fetch(myCfg.appSettings.webApiServerBaseUrl + `api/Proxy/CustomerRequestInitialData?CompanyCode=${CompanyCode}&serviceDateRequested=${serviceDateRequested.toUTCString()}&serviceMasterNum=${serviceMasterNum}&FunctionCode=${functionCode}&ComponentCode=${componentCode}&ServiceOrMaintenance=${serviceOrMaintenance}`,
            {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' }
            })
            .then(response => response.json() as Promise<APIContainer>)
            .then(container => {
                //Do something with response                
                if (container.success) {
                    const data: CustomerRequestInitalDataMdl.CustomerRequestInitialDataItem = container.data;
                    dispatch({ type: 'CUSTOMERREQUESTINITIALDATA_LOADINFO', data: { items: data, loading: false, error: '', loaded:true } });
                } else {
                    sawinFunc.log({ message: container.errorInfo.message, logType: LogTypes.Error, clientMessage: '' });
                }

            })
            .catch(function (err: Error) {
                dispatch({
                    type: 'CUSTOMERREQUESTINITIALDATA_ERROR', error: err.message
                })
            });
    },
    loadTaskInfo: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
        const appState = getState();
        const sessionState: SessionModel = appState.sessionState;
        var CompanyCode = sessionState.SelectedAR.companyCode;

        dispatch({ type: 'CUSTOMERREQUESTINITIALDATA_LOADING', loading: true });
        sawinFunc.fetch(myCfg.appSettings.webApiServerBaseUrl + `api/Proxy/CustomerRequestTaskInfo?CompanyCode=${CompanyCode}`,
            {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' }
            })
            .then(response => response.json() as Promise<APIContainer>)
            .then(container => {
                //Do something with response                
                if (container.success) {
                    const data: CustomerRequestInitalDataMdl.CustomerRequestTaskInfoItem[] = container.data;
                    dispatch({ type: 'CUSTOMERREQUESTINITIALDATA_LOADTASKS', data: data });
                } else {
                    sawinFunc.log({ message: container.errorInfo.message, logType: LogTypes.Error, clientMessage: '' });
                }

            })
            .catch(function (err: Error) {
                dispatch({
                    type: 'CUSTOMERREQUESTINITIALDATA_ERROR', error: err.message
                })
            });
    }
};

export const reducer: Reducer<CustomerRequestInitalDataMdl.CustomerRequestInitialData> = (state: CustomerRequestInitalDataMdl.CustomerRequestInitialData | undefined, incomingAction: Action): CustomerRequestInitalDataMdl.CustomerRequestInitialData => {

    if (state === undefined) {
        return { ...CustomerRequestInitalDataMdl.initialInfo };
    }
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'CUSTOMERREQUESTINITIALDATA_LOADING':
            return { ...state, loading: (action as CustomerRequestInitialDataLoading).loading }
        case 'CUSTOMERREQUESTINITIALDATA_ERROR':
            return { ...state, loading: false, error: (action as CustomerRequestInitialDataError).error }
        case 'CUSTOMERREQUESTINITIALDATA_LOADINFO':
            var data: CustomerRequestInitalDataMdl.CustomerRequestInitialData = (action as CustomerRequestInitialDataLoadInfo).data;
            return {
                ...state,
                items: { ...state.items, timePromissedOptions: data.items.timePromissedOptions, serviceRequestMessage: data.items.serviceRequestMessage }, loaded: data.loaded, loading:data.loading, error:data.error
            };
        case 'CUSTOMERREQUESTINITIALDATA_LOADTASKS':
            var taskInfo = (action as CustomerRequestInitialDataLoadTaskList).data;            
            return {
                ...state, ...{
                    items: { ...state.items, taskInfoList: taskInfo }, loading: false
                }
    }
        default:
            return state;
    }
}; 